import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import { Size } from '../../../../Enums/Size.enum';
import ORSMDomainChange from './ORSMDomainChange';

interface Props extends BaseModalProps {
	rootWorkplaceId: string;
	onChange: () => void;
}

const ORSMDomainChangeModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.ORSMDomainChange.modalTitle'
			size={Size.LG}>
			<ORSMDomainChange
				rootWorkplaceId={props.rootWorkplaceId}
				onChange={props.onChange}
			/>
		</BaseModal>
	);
};

export default ORSMDomainChangeModal;
